"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TIP : STYLES --------------- ++++++++++ */


var tipSpaceSize = 7;
var _default = {
  tip: {
    // check app_styles for more '.tippy-tooltip'
    color: "rgba(6, 43, 117, 0.5)",
    '&.space': {
      '&-left': {
        marginLeft: (0, _index.pxToEm)(tipSpaceSize)
      },
      '&-right': {
        marginRight: (0, _index.pxToEm)(tipSpaceSize)
      },
      '&-around': {
        marginLeft: (0, _index.pxToEm)(tipSpaceSize),
        marginRight: (0, _index.pxToEm)(tipSpaceSize)
      }
    }
  }
};
exports.default = _default;